import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "@angular/fire/database";
import { Observable } from "rxjs";
import { database } from "firebase";
import { ElementoCatalogo } from "../models/entities/elemento-catalogo";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ObrasControlService {
  public path: string;

  constructor(public angularFireDatabase: AngularFireDatabase) {
    this.path = "obrasControl";
  }

  public save(obraControl: ElementoCatalogo): Promise<any> {
    return this.angularFireDatabase
      .list<ElementoCatalogo>(this.path)
      .push(obraControl);
  }

  public updateControlObra(key: string, controlobra: any): Promise<any> {
    return this.angularFireDatabase
      .list<any>(this.path)
      .update(key, controlobra);
  }

  public delete(key: string): Promise<any> {
    return this.angularFireDatabase.list<any>(this.path).remove(key);
  }

  obtenerObrasControl(): Observable<any[]> {
    return this.angularFireDatabase
      .list<any>(this.path)
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            key: c.payload.key,
            ...c.payload.val(),
          }))
        )
      );
  }
}
